import { Card, Grid, Paper, Stack, Typography } from "@mui/material";
import { useGetSalesRepFindersQuery } from "../../features/model/salesrepSlice";
import Loading from "../../components/Loading";
import { formatPhone } from "../../helpers/strings";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const DistributorItem = ({distributor}) => {
    var phonenumber = ""
    let metadata = JSON.parse(distributor.metadata)
    if("phone" in metadata) {
        phonenumber = metadata["phone"]
        phonenumber = formatPhone(phonenumber)
    }
    return <Grid item sx={{maxWidth: "300px"}}>
        <Paper sx={{margin: 2, padding: 2}}>
            <Stack direction="column">
            <Typography variant="h3">{distributor.name}</Typography>
            <Typography variant="p">{distributor.email}</Typography>
            <Typography variant="p">{phonenumber}</Typography>
            <Typography variant="subtitle2">Registered {dayjs.utc(distributor.added).local().format("M/D/YYYY")}</Typography>
            </Stack>
        </Paper>
    </Grid>
}

const SalesRepDistributorsListView = ({salesrep}) => {
    const {data, error, isLoading } = useGetSalesRepFindersQuery(salesrep.id)

    if(isLoading) return <Loading />
    if(error) return <></>
    if(!(data.objects)) return <></>
    
    return <Paper>
        <Card>
           <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Registered distributors</Typography>
                <Grid container>
                    {data.objects.filter((f) => {return f.type==="distributor"}).map((rep, i) => <DistributorItem key={rep.id} distributor={rep} />)}
                </Grid>
            </Stack>
        </Card>
    </Paper>

}

export { SalesRepDistributorsListView };